// extracted by mini-css-extract-plugin
export default {"list":"Catalog_list__2CkPq","card":"Catalog_card__viMAl","btns":"Catalog_btns__5kklB","button":"Catalog_button__cn4ft","loader":"Catalog_loader__QYbve"};